<template>
  <div class="orderCountTable">
    <!-- 类型/三方名称/主订单号/子订单号/售后单号/推送时间
      /供货时间/售后确认时间/状态/单位/锐锢编码/三方编码
      /商品名称/供货成交价/数量/供货金额/OMS单据状态
      /核算确认时间/结算周期/预计结算时间/结算时间/结算状态
      /结算金额/付款/扣款时间 -->
    <el-table :data="data"  :summary-method="getSummaries" show-summary border fit  max-height="500">
      <el-table-column type="index" label="序号" width="50" fixed="left">
      </el-table-column>
      <el-table-column prop="order_type_text" label="类型">
      </el-table-column>
      <el-table-column prop="supply_time" label="供货时间/售后确认时间" width="130">
      </el-table-column>
      <el-table-column prop="sku_name" label="商品名称" width="130px">
      </el-table-column>
      <el-table-column prop="order_quantity" label="数量" width="50px">
        <template slot-scope="scope">
          <span>{{scope.row.order_quantity | fixedNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="unit" label="单位" width="50px">
      </el-table-column>
      <el-table-column prop="order_price" label="供货成交价">
      </el-table-column>
      <el-table-column prop="order_amount" label="供货金额">
      </el-table-column>
      <el-table-column prop="real_settle_date" label="结算时间" width="130px">
      </el-table-column>
      <el-table-column prop="payment_bill_status_text" label="结算状态">
      </el-table-column>
      <el-table-column prop="total_amount" label="结算金额">
      </el-table-column>
      <el-table-column prop="paid_on" label="付款/扣款时间" width="130px">
      </el-table-column>
      <el-table-column prop="main_number" label="主订单号" width="130px">
      </el-table-column>
      <el-table-column prop="order_number" label="子订单号" width="130px">
      </el-table-column>
      <el-table-column prop="ap_order_status_text" label="主单状态">
      </el-table-column>
      <el-table-column prop="shop_name" label="三方名称" width="130px">
      </el-table-column>
      <el-table-column prop="as_number" label="售后单号" width="130px">
      </el-table-column>
      <el-table-column prop="push_time" label="推送时间" width="130px">
      </el-table-column>
      <el-table-column prop="ap_order_detail_status_text" label="子单状态">
      </el-table-column>
      <el-table-column prop="sku_code" label="锐锢编码" width="100px">
      </el-table-column>
      <el-table-column prop="order_status_text" label="OMS单据状态">
      </el-table-column>
      <el-table-column prop="payment_bill_created_on" label="核算确认时间" width="130px">
      </el-table-column>
      <el-table-column prop="expect_settle_date" label="预计结算时间" width="130px">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
const isType = type => target => `[object ${type}]` === Object.prototype.toString.call(target)
const isNumber = isType('Number')
export default {
  props: ['data'],
  data () {
    return {
    }
  },
  filters: {
    fixedNumber (val) {
      let value = Number(val)
      return isNaN(isNumber(value)) ? '' : parseFloat(value)
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (index === 0) {
          sums[index] = '合计'
          // return
        } else if (index === 14) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
        } else if (index === 15) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
        } else if (index === 21) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = (values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)).toFixed(2)
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    }
  }
}
</script>
<style lang="scss" scoped>
p{
  word-wrap: none;
}
</style>



// WEBPACK FOOTER //
// src/components/report/OrderCountTable.vue